import React, { useState, useEffect } from 'react';
import { get_dlqi_plqi } from "../Services/Service";

function Easi({ uuid }) {
    const [easiResponse, setEasiResponse] = useState([]);

    useEffect(() => {
        const fetchEasi = async () => {
            try {
                const easiResponse = await get_dlqi_plqi({ uuid: uuid, type: "easi" });
                console.log(easiResponse);
                setEasiResponse(easiResponse.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchEasi();
    }, [uuid]); // Run effect whenever `uuid` changes

    return (
        <div className='row'>
            {easiResponse.map(easiVal => (
                <> {/* Add a unique key for each item */}
                    <div className='col-md-4 mt-4 border-start px-5'>
                        <div className='row align-items-center'>
                            <div className='col-auto'>
                                <p className='person-subtitle mb-0'>{easiVal.date}</p>
                            </div>
                            <div className='col'>
                                <p className='person-subtitle mb-0'>Click Here <a target="_blank" className='dliq-btn' href={easiVal.link}>OPEN </a></p>
                            </div>
                        </div>
                    </div>
                </>

            ))}
        </div>

    );
}

export default Easi;
